module.exports = __webpack_public_path__ + "img/sq-bg5.9d6ca5b5.png";